<template>
  <div
    class="@container relative inline-block"
    :class="[props.coins.length > 3 ? 'text-xs' : 'text-sm']"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 30 30"
      fill="none"
      class="absolute absolute-center w-full h-full"
    >
      <g filter="url(#filter0_i_4336_36315)">
        <circle cx="15" cy="15" r="15" fill="url(#paint0_linear_4336_36315)" />
      </g>
      <circle
        cx="15"
        cy="15"
        r="14.5"
        stroke="url(#paint1_linear_4336_36315)"
      />
      <defs>
        <filter
          id="filter0_i_4336_36315"
          x="0"
          y="0"
          width="30"
          height="32"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_4336_36315"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4336_36315"
          x1="30"
          y1="0"
          x2="0"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFCA17" />
          <stop offset="1" stop-color="#977400" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4336_36315"
          x1="30"
          y1="0"
          x2="0"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFEDDB" />
          <stop offset="1" stop-color="#AB8F54" />
        </linearGradient>
      </defs>
    </svg>

    <p
      class="absolute text-[38cqw] inset-0 flex items-center justify-center text-white font-normal font-serif [text-shadow:0px_2px_4px_rgba(0,_0,_0,_0.15)]"
    >
      {{ props.coins }}
    </p>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  coins: string;
}>();
</script>
